import type { components } from '../openapi.generated'

import { isRecord, nullableString, requireBoolean } from './decode'

export type PageInfo = components['schemas']['PageInfo']

export type PagedResponse<T> = {
  items: T[]
  pageInfo: PageInfo
}

export function decodePageInfo(raw: unknown): PageInfo {
  if (!isRecord(raw)) throw new Error('Malformed page info')
  return {
    hasNextPage: requireBoolean(raw.hasNextPage, 'hasNextPage'),
    endCursor: nullableString(raw.endCursor, 'endCursor'),
  } satisfies PageInfo
}

export function decodePage<T>(
  raw: unknown,
  decodeItem: (raw: unknown) => T,
  label: string,
): PagedResponse<T> {
  if (!isRecord(raw) || !Array.isArray(raw.items))
    throw new Error(`Malformed ${label}`)
  return {
    items: raw.items.map(decodeItem),
    pageInfo: decodePageInfo(raw.pageInfo),
  }
}
